import { APIS } from '../../../../../utils/api-factory'
import LocalStrorageUtility from '../../../../../utils/localStorageUtil'
import moment from 'moment'
import axios from 'axios'

export const getDealerDetailsList = ( callBack, error) => {
    axios.get(APIS.GET_DEALER_LIST_DETAILS + "?id=0")
        .then(res => {
            callBack(res?.data)
        })
        .catch(e => {
            callBack("")
        })
}
export const SaveDealerData = (data, callBack, error) => {
    axios.post(APIS.SAVE_DEALER_DATA, data)
        .then(res => {
            callBack(res?.data)
        })
        .catch(e => {
            callBack("")
        })
}
export const UpdateDealerData = (data, callBack, error) => {
    axios.post(APIS.UPDATE_DEALER_DATA, data)
        .then(res => {
            callBack(res?.data)
        })
        .catch(e => {
            callBack("")
        })
}
export const DeleteDealerData = (id, callBack, error) => {
    axios.delete(APIS.DELETE_DEALER_DATA + id)
        .then(res => {
            callBack(res?.data)
        })
        .catch(e => {
            callBack("")
        })
}